export interface WineWidgetModel {
  title: string;
  id: number;
  productVariantId: number;
  imgUrl: string;
  availableQuantity: number;
  description: string;
  basePrice: number | null;
  discount: number;
  currentPrice: number | null;
  productYear: number;
  manufacturerName?: string;
  isManufacturer?: boolean;

  currentEurPrice: number | null;

  baseEurPrice: number | null;
  showEurPrice: boolean;
  minimumCartQuantity: number;
  maximumCartQuantity: number;
  tags: string[];
}

export const getFeaturedWines = async () => {
  try {
    const response = await fetch(`/Widget/FeaturedWines`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return (await response.json()) as WineWidgetModel[];
  } catch (error) {
    throw new Error('Probléma történt az adatok lekérdezése közben.');
  }
};
